var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#515864",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.7h13.5a.3.3 0 01.3.3v.5h-2.134a2 2 0 00-2 2v6.3H4a.3.3 0 01-.3-.3V6a.3.3 0 01.3-.3zm9.666 10.8H4a2 2 0 01-2-2V6a2 2 0 012-2h13.5a2 2 0 012 2v.5h.5a2 2 0 012 2V17a2 2 0 01-2 2h-4.334a2 2 0 01-2-2v-.5zm1.668-7.834a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1.5zm.417 3.667a.417.417 0 000 .833h4.166a.417.417 0 100-.833h-4.166zM17 16.453a.787.787 0 111.574 0 .787.787 0 01-1.574 0zm-8.936.973c-.869 0-1.574.705-1.574 1.574h6.296v-1.574H8.064z"
  })));
}
export default SvgPc;